import { WqSwal as Swal } from "./themedSwal";
import { notifyParent } from "./embed";
import { goToPaymentSuccessPage } from "./paymentSuccessLock";
import { getOpenerOrigin, notifyOpener } from "./openerMessaging";


// Callers pass the reference as refNo (most) or tranId (Four.jsx); accept both.
export const finalizePaymentSuccess = ({ message, refNo, tranId, isEmbedded, notifyExtra = {} }) => {
  Swal.fire({
    title: "Success",
    text: message || "Payment successful",
    icon: "success",
    confirmButtonText: "Ok",
    timer: 10000,
    timerProgressBar: true,
  }).then(() => {
    const callback = sessionStorage.getItem("fallbackUrl");
    const referrer = sessionStorage.getItem("referrer");
    const isBadReferrer = referrer?.includes("_tranId");

    // A real redirect target only exists if the merchant configured a
    // callback, or there's a referrer we trust. No more defaulting this to
    // "https://wayaquick.com" here — that's now a last-resort fallback below,
    // not something we redirect to on purpose.
    const redirectUrl = callback || (referrer && !isBadReferrer ? referrer : null);

    if (isEmbedded) {
      sessionStorage.clear();
      notifyParent("success", notifyExtra);
      return;
    }

    // Read before the clear below wipes it.
    const openerOrigin = getOpenerOrigin();

    sessionStorage.setItem("paymentCompleted", "true");
    const completedFlag = sessionStorage.getItem("paymentCompleted");
    sessionStorage.clear();
    sessionStorage.setItem("paymentCompleted", completedFlag);

    const isPopup = window.opener && !window.opener.closed;
    if (isPopup) {
      notifyOpener({ type: "PAYMENT_SUCCESS", tranId: refNo ?? tranId }, openerOrigin);
      window.close();
      return;
    }

    if (redirectUrl) {
      // Payment link with no merchant callback: the tab can't be closed by
      // script, so land on the terminal success page (history locked there)
      // instead of sending the customer back to the payment-link form.
      if (redirectUrl.includes("payment-link")) {
        goToPaymentSuccessPage();
        return;
      }
      window.location.replace(redirectUrl);
      return;
    }

    // No merchant callback and no usable referrer: try closing the tab
    // instead of dumping the customer on wayaquick.com. window.close() only
    // works on tabs the script itself opened — most browsers silently ignore
    // it otherwise, in which case nothing happens and this code keeps
    // running. So fall back to the old redirect a beat later; if the close
    // actually succeeded, the page (and this timeout) is already gone by
    // then, so the fallback never fires.
    window.close();
    setTimeout(() => {
      window.location.replace("https://wayaquick.com");
    }, 300);
  });
};

export const showPaymentError = (err, fallback) => {
  Swal.fire({
    title: "Error",
    text:
      err?.response?.data?.data ||
      err?.response?.data?.message ||
      err?.response?.data?.description ||
      fallback ||
      "Something went wrong, please try again",
    icon: "error",
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Ok",
  });
};

export const showPaymentPending = (message = "Your transfer has not been received yet. Please wait a moment and try again.") => {
  Swal.fire({
    title: "Payment Pending",
    text: message,
    icon: "info",
    confirmButtonText: "Okay",
    confirmButtonColor: "#3085d6",
    allowOutsideClick: false,
  });
};
